import React from 'react';

export function AuthBar({
  user, initials, canEdit,
  authEmail, setAuthEmail,
  authPassword, setAuthPassword,
  handleLogin, handleLogout
}) {
  return (
    <div className="auth-bar">
      {user ? (
        <>
          <div className="auth-avatar">
            {initials}
          </div>
          <div className="auth-info">
            <span className="auth-email">{user.email}</span>
            <span className="auth-role">
              {user.role}
              {!canEdit && ' · lecture seule'}
            </span>
          </div>
          <button className="auth-logout" onClick={handleLogout}>
            Se déconnecter
          </button>
        </>
      ) : (
        <form className="auth-form" onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={authEmail}
            onChange={(e) => setAuthEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={authPassword}
            onChange={(e) => setAuthPassword(e.target.value)}
          />
          <button type="submit">Connexion</button>
          {/* <button
            type="button"
            onClick={handleRegister}
          >
            Créer un viewer
          </button> */}
        </form>
      )}
    </div>
  );
}
